var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFailedUg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFailedUg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-upgrade",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment-Options-failed",
    transform: "translate(-158.000000, -92.000000)",
    fill: "#FF0400",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(158.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2333333,31.8674631 C63.2333333,49.1460925 49.1460925,63.2333333 31.8674631,63.2333333 C14.5885558,63.2333333 0.5,49.1458145 0.5,31.8674631 C0.5,14.5888338 14.5888338,0.5 31.8674631,0.5 C49.1458145,0.5 63.2333333,14.5885558 63.2333333,31.8674631 Z M60.2333333,31.8674631 C60.2333333,16.2453606 47.4889108,3.5 31.8674631,3.5 C16.245688,3.5 3.5,16.245688 3.5,31.8674631 C3.5,47.4889108 16.2453606,60.2333333 31.8674631,60.2333333 C47.4892382,60.2333333 60.2333333,47.4892382 60.2333333,31.8674631 Z M34.8129498,32.8000488 L42.3216138,40.216022 C43.0127954,40.8986712 43.0127954,42.0053638 42.3216138,42.6880131 C41.6304323,43.3706623 40.5098085,43.3706623 39.8187258,42.6880131 L32.3099629,35.2719422 L24.8012,42.6880131 C24.1100185,43.3706623 22.9894935,43.3706623 22.298312,42.6880131 C21.6072293,42.0054615 21.6072293,40.8986712 22.298312,40.216022 L29.8070749,32.7999512 L22.298312,25.383978 C21.6072293,24.7014264 21.6072293,23.5946362 22.298312,22.9119869 C22.9894935,22.2293377 24.1100185,22.2293377 24.8012,22.9119869 L32.3099629,30.3281554 L39.8187258,22.9120846 C40.5099074,22.2294354 41.6304323,22.2294354 42.3216138,22.9120846 C43.0127954,23.5946362 43.0127954,24.7014264 42.3216138,25.3840756 L34.8129498,32.8000488 Z",
    id: "icFailedUg"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFailedUg);
export default __webpack_public_path__ + "static/media/icFailedUg.5000d011974be664f92751a17020ba54.svg";
export { ForwardRef as ReactComponent };